import React from 'react';
import { FormGroup, Label, Card, CardHeader, CardBody, Col } from 'reactstrap';
import { range } from 'lodash';

import { ISettingsPayments } from 'types';

import { NumberSelect } from '../../components';

export type PaymentsCardProps = {
  handleChange: any;
  payments: ISettingsPayments;
};

export const PaymentsCard = (props: PaymentsCardProps) => {
  const { handleChange, payments } = props;

  return (
    <Card className="mb-3">
      <CardHeader tag="h5">Payments</CardHeader>
      <CardBody>
        <FormGroup row>
          <Label xs={12} className="font-weight-bold">
            Statement Descriptor
          </Label>

          <Col xs={6}>
            <p className="mb-0">{payments?.statementDescriptor || '––'}</p>
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label xs={12} for="payments.defaultNetPaymentTerms" className="font-weight-bold">
            Default Net Payment Terms
          </Label>

          <Col xs={6}>
            <select
              className="form-control"
              id="payments.defaultNetPaymentTerms"
              name="payments.defaultNetPaymentTerms"
              onChange={handleChange}
              value={payments.defaultNetPaymentTerms}
            >
              <option value="5">Net 7</option>
              <option value="0">Net 10</option>
              <option value="1">Net 15</option>
              <option value="6">Net 20</option>
              <option value="2">Net 30</option>
              <option value="3">Net 45</option>
            </select>
          </Col>
        </FormGroup>

        <NumberSelect
          value={payments.portfolioDaysToMature}
          field="payments.portfolioDaysToMature"
          onChange={handleChange}
          options={range(0, 91)}
        />

        <NumberSelect
          value={payments.daysInAdvanceToRemindPayment}
          field="payments.daysInAdvanceToRemindPayment"
          onChange={handleChange}
          options={range(0, 21)}
        />
      </CardBody>
    </Card>
  );
};
